import { JobPeriod } from 'types/AppTypes';

export const isJobPeriodActive = (jobPeriod: JobPeriod) => {
  const date = new Date();

  return (
    new Date(jobPeriod.startDate) <= date &&
    date <= new Date(jobPeriod.endDate) &&
    jobPeriod?.isCanceled !== true
  );
};
